export const LIMITS_SECTION_SKELETON_COUNT = 4;
